import { collapseStore } from '../stores';

function toogleCollapse() {
  collapseStore.toogle();
}

export { toogleCollapse };
